import React from 'react'
import { Box, HStack } from '@chakra-ui/react'
import { CardStatusesType } from '../../../pages/workspace-page/resource-card/ResourceCard'

export const CardStatuses = ({
  statuses,
  offsetRight = false
}: {
  statuses: CardStatusesType
  offsetRight?: boolean
}) => {
  return statuses ? (
    <HStack
      position="absolute"
      top="8px"
      right="8px"
      spacing="8px"
      pr={offsetRight ? ['20px', '32px'] : undefined}
    >
      {Array.isArray(statuses)
        ? statuses.map((tag, index) => <Box key={index}>{tag}</Box>)
        : statuses}
    </HStack>
  ) : null
}
